// audioCache.js
const CACHE = new Map();

export async function playAudio(url, volume = 0.6) {
  // if already cached, reuse
  let entry = CACHE.get(url);
  if (!entry) {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to fetch audio: ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const audio = new Audio(objectUrl);
    audio.preload = "auto";
    audio.volume = volume; // set default volume to 60%
    entry = { audio, objectUrl };
    CACHE.set(url, entry);
  }

  entry.audio.currentTime = 0;
  try {
    await entry.audio.play();
  } catch (err) {
    console.warn("Playback failed:", err);
  }
}
